module.exports = __webpack_public_path__ + "static/media/edgar_lee.7caddc76.png";